export const getPermittedFunctionalities = (functionalities, permissions) => {
  return permissions.reduce((permissions, permission) => {
    const functionality = functionalities.find(item => {
      return item.functionality === permission.alias
    })

    if (functionality) {
      return [...permissions, functionality]
    } else {
      return [...permissions]
    }
  }, [])
}

// `functionality` aceita UMA alias ou uma lista separada por espaço ("a b" = a OU b),
// a mesma convenção já usada nos itens de menu (actions/menu.js). Sem isso, telas cujo
// backend autoriza duas permissões (ex.: incompatibility-analysis OU
// incompatibility-analysis-edit) precisariam repetir o <Can> uma vez por alias.
export const can = (functionality, permissions) => {
  const aliases = `${functionality}`.split(/\s+/).filter(Boolean)

  return !!permissions.find(item => aliases.indexOf(item.alias) !== -1)
}



// WEBPACK FOOTER //
// ./src/utils/permissions.js